import React from 'react'
import { Modal, ModalBody } from "reactstrap";
import CloudStorage from '../../../CloudStorage/CloudStorage';

export default function LogoutModel({modal, getModalToggleHandler, modalContentRefs, LogoutMethod}) {
  return (
    <div>
      <Modal
          className="popupmodal logout"
          isOpen={modal}
          toggle={getModalToggleHandler('logout')}
        >
          <div ref={modalContentRefs.logout}>
            <button
              onClick={getModalToggleHandler('logout')}
              className="btn close-button"
            >
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
                alt=""
              />
            </button>
            <ModalBody>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/info-circle.svg`}
                alt=""
              />
              <h4>Logout</h4>
              <p>Are you sure you want to logout</p>
            </ModalBody>
            <div className="modal-footer mt-3">
              <button
                className="btn no"
                onClick={getModalToggleHandler('logout')}
              >
                No
              </button>
              <button
                className="btn"
                onClick={() => {
                  getModalToggleHandler('logout')();
                  LogoutMethod();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </Modal>
    </div>
  )
}
